var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthcompliance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4996 28.9473V36.8421H49.9991V42.1053H42.4971L42.4996 50H37.4999L37.4974 42.1053H30.0005V36.8421H37.4999V28.9473H42.4996ZM45.6069 4.62364C51.2615 10.5921 51.4565 20.0973 46.1968 26.2947L42.6471 22.5631C45.9744 18.5526 45.7994 12.2631 42.0671 8.34206C38.3099 4.39732 32.2678 4.2289 28.3431 7.93943L25.0058 11.0921L21.666 7.94206C17.7288 4.22627 11.6892 4.38943 7.93197 8.34732C4.20723 12.2684 4.01974 18.5447 7.452 22.6921L28.5306 44.9184L25.0008 48.6447L3.80225 26.2973C-1.45738 20.0973 -1.2599 10.5763 4.39221 4.62364C10.0543 -1.33426 19.1112 -1.53427 25.0008 4.02364C30.8729 -1.52637 39.9473 -1.34216 45.6044 4.62364H45.6069Z",
    fill: "#9D2222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcompliance);
export default __webpack_public_path__ + "static/media/healthcompliance.1ee247d6958739dea0067c0301537d86.svg";
export { ForwardRef as ReactComponent };